<template>
  <transition
    v-if="showBadge"
    name="fade"
  >
    <div
      :class="[
        'badge',
        `badge-${variant}`,
        {
          'badge-shape--rounded': rounded && (iconPosition || labelLength >= 3),
          'badge-shape--circle': rounded && !iconPosition && labelLength < 3,
          'badge-sm': size === 'slim'
        }
      ]"
    >
      <div class="d-flex">
        <m-icon
          v-if="iconPosition === 'left'"
          v-on="$listeners"
          :variant="iconVariant"
          size="small"
        />
        <span
          ref="badgeLabel"
          :class="[{
            'badge-font--rounded': rounded && (iconPosition || labelLength >= 3),
            'badge-font--circle': rounded && !iconPosition && labelLength < 3,
          }]"
        >
          <slot>{{ label }}</slot>
        </span>
        <m-icon
          v-if="iconPosition === 'right'"
          v-on="$listeners"
          :variant="iconVariant"
          size="small"
        />
      </div>
    </div>
  </transition>
</template>

<script>
import MIcon from '../../components/Icon';

export default {
  name: 'MBadge',
  components: {
    MIcon,
  },
  props: {
    size: {
      type: String,
      default: '',
    },
    rounded: {
      type: Boolean,
      default: false,
    },
    variant: {
      type: String,
      default: 'success',
    },
    label: {
      type: [String, Number],
      default: '',
    },
    iconPosition: {
      type: String,
      default: '',
    },
    iconVariant: {
      type: String,
      default: 'reset',
    },
    showBadge: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    labelLength() {
      return this.label ? String(this.label).length : 3;
    },
  },
};
</script>
<style lang="scss" scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity .2s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>
